var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4a2.5 2.5 0 0 1 2.5-2.5h7.558c.423 0 .82.178 1.106.478.289.304.74.765 1.17 1.15.365.326.925.9 1.251 1.238.27.278.415.65.415 1.032V16a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 16zm13 1.5v-.102a.49.49 0 0 0-.135-.338c-.33-.343-.865-.89-1.198-1.187-.46-.412-.933-.896-1.228-1.206a.53.53 0 0 0-.38-.167H13V5a.5.5 0 0 0 .5.5zm-4-3V5a1.5 1.5 0 0 0 1.5 1.5H16V16a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 4 16V4a1.5 1.5 0 0 1 1.5-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgFile;